<div class="main-container">
    <div class="header">
        <div
            class="col1 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center"
        >
            <cmps-icon
                class="cmps-cdk-d-block cmps-cdk-transform-scale-2"
                svgIcon="alert-circle"
            ></cmps-icon>
        </div>
        <div class="col2">
            <span
                ><strong>{{
                    _i18n._9716_YOU_CANNOT_PUBLISH_THIS_OBSERVATION_SESSION
                        | translate
                }}</strong
                ><br />{{
                    _i18n._9717_UPDATE_MANDATORY_FIELD_S__LISTED_BELOW__MANDATORY_FIELDS_WILL_
                        | translate
                }}</span
            >
        </div>
        <div class="col3">
            <button
                class="cmps-icon-button--no-bg cmps-icon-button--no-bg--white close_button"
                cmpsIconButton
                (click)="_dialogRef?.close()"
            >
                <cmps-icon svgIcon="close"></cmps-icon>
            </button>
        </div>
    </div>
    <div class="body">
        <ng-container *ngIf="!_data?.isValidFocus || !_data?.isInteraction">
            <div class="row1 body_Item">
                <span *ngIf="!_data?.isValidFocus; else elseBlock"
                    ><strong>{{
                        _i18n._9718_FOCUS_CONTAINER | translate
                    }}</strong
                    ><br />
                    {{
                        _i18n._9719_SELECT_A_FOCUS_TO_BE_ASSIGNED_AND_ONE_OF_THE_FOLLOWING_BELOW_
                            | translate
                    }}
                </span>
                <ng-template #elseBlock
                    ><span
                        ><strong>{{
                            _i18n._9720_PERFORM_ONE_OF_THE_FOLLOWING_
                                | translate
                        }}</strong></span
                    >
                </ng-template>
            </div>
            <div class="row2 body_Item">
                <span
                    ><strong>{{ _i18n._9698_NOTE | translate }}</strong
                    ><br />
                    {{
                        _i18n._9721_PLEASE_ENTER_TEXT_FOR_AT_LEAST_ONE_NOTE
                            | translate
                    }}</span
                >
            </div>
            <div
                class="or body_Item"
                [class.d-none]="!_data?.isValidFocus && !_data?.isInteraction"
            >
                <span>{{ _i18n._9724_OR | translate | uppercase }}</span>
            </div>
            <div class="row3 body_Item">
                <span
                    ><strong>{{
                        _i18n._9722_EVALUATION_INTERACTION_FOCUS | translate
                    }}</strong
                    ><br />
                    {{ _i18n._9723_EVALUATE_THE_FOCUS | translate }}</span
                >
            </div>
            <div
                class="or body_Item"
                [class.d-none]="!_data?.isValidFocus && !_data?.isInteraction"
            >
                <span>{{ _i18n._9724_OR | translate | uppercase }}</span>
            </div>
            <div class="row4 body_Item">
                <span
                    ><strong>{{ _i18n._7424_DELETE | translate }}</strong>
                    {{
                        _i18n._9725_THE_HIGHLIGHTED_CONTAINERS_FROM_THE_SESSION
                            | translate
                    }}</span
                >
            </div>
        </ng-container>

        <!--low effort checks. still want to refactor to use form group validators instead in the future-->
        <div
            class="body_Item"
            *ngIf="
                _data?.isValidFocus &&
                _data?.isInteraction &&
                (_data?.invalidEvaluationWillingness ||
                    _data?.invalidEvaluationProficiency)
            "
        >
            <span>
                <strong>{{ _i18n._534_EVALUATION | translate }}</strong>
                <br />
                <ng-container *ngIf="_data?.invalidEvaluationWillingness">
                    {{
                        _i18n._9669_SELECT_A_VALUE_FOR_WILLINGNESS_TO_TRY
                            | translate
                    }}
                </ng-container>
                <ng-container *ngIf="_data?.invalidEvaluationProficiency">
                    {{
                        _i18n._9670_SELECT_A_VALUE_FOR_THE_PROFICIENCY_SCORE
                            | translate
                    }}
                </ng-container>
            </span>
        </div>
    </div>
</div>
